import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-900/5 tw-p-4" }
const _hoisted_2 = { class: "tw-flex tw-items-start tw-justify-between tw-gap-3" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_4 = { class: "tw-text-base tw-font-semibold tw-text-slate-900" }
const _hoisted_5 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_6 = {
  key: 0,
  class: "tw-mt-3 tw-text-sm tw-text-slate-700"
}
const _hoisted_7 = { class: "tw-font-medium tw-text-slate-900" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "tw-mt-3 tw-text-sm tw-text-slate-700"
}
const _hoisted_10 = {
  key: 2,
  class: "tw-mt-3 tw-flex tw-w-full tw-items-center tw-gap-2"
}
const _hoisted_11 = { class: "tw-min-w-0 tw-flex-1" }
const _hoisted_12 = { class: "tw-inline-flex tw-h-10 tw-shrink-0 tw-overflow-hidden tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white/70" }
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          icon: "location-dot",
          class: "tw-h-4 tw-w-4 tw-text-slate-500"
        }),
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.isExportOrder ? 'Drop-Off Terminal' : 'Pick-Up Terminal'), 1),
        (_ctx.locationCopyValue)
          ? (_openBlock(), _createBlock(_component_CopyButton, {
              key: 0,
              value: _ctx.locationCopyValue,
              title: _ctx.isExportOrder ? 'Copy drop-off location' : 'Copy pick-up location',
              ariaLabel: _ctx.isExportOrder ? 'Copy drop-off location' : 'Copy pick-up location'
            }, null, 8, ["value", "title", "ariaLabel"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.editable)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-white",
              title: "Edit terminal",
              "aria-label": "Edit terminal",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleEditingTerminal && _ctx.toggleEditingTerminal(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "pen-to-square" })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.order.pickUpLocation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.order.pickUpLocation.name), 1),
          (_ctx.order.pickUpLocation.address)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.addressLine2(_ctx.order.pickUpLocation.address)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, _toDisplayString(_ctx.addressLine3(_ctx.order.pickUpLocation.address)), 1)
        ]))
      : (_ctx.order.billOfLading && _ctx.order.billOfLading.pickUpLocation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.order.billOfLading.pickUpLocation), 1))
        : _createCommentVNode("", true),
    (_ctx.isEditingTerminal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_FilterableDropdown, {
              class: "tw-w-full tw-min-w-0",
              placeholder: "Select terminal",
              options: _ctx.terminals,
              customLabel: (x) => (x.shortName ? x.shortName : x.name),
              modelValue: _ctx.selectedTerminal,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTerminal) = $event))
            }, null, 8, ["options", "customLabel", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              class: "tw-inline-flex tw-h-10 tw-items-center tw-justify-center tw-px-3 tw-text-slate-700 hover:tw-bg-white disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
              disabled: _ctx.savingTerminal || !_ctx.selectedTerminal?.id,
              title: "Save",
              "aria-label": "Save",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveTerminal && _ctx.saveTerminal(...args)))
            }, [
              (_ctx.savingTerminal)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "circle-notch",
                    spin: ""
                  }))
                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 1,
                    icon: "check"
                  }))
            ], 8, _hoisted_13),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "tw-w-px tw-bg-slate-200/70" }, null, -1)),
            _createElementVNode("button", {
              type: "button",
              class: "tw-inline-flex tw-h-10 tw-items-center tw-justify-center tw-px-3 tw-text-slate-700 hover:tw-bg-white",
              title: "Cancel",
              "aria-label": "Cancel",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelEditTerminal && _ctx.cancelEditTerminal(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "xmark" })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}